import React from 'react';
import { Bg, Br, Cz, De, Es, Fi, Fr, Hr, Hu, Ir, It, Jp, Mn, Nl, No, Pl, Ro, Rs, Ru, Sa, Se, Sk, Tr, Ua, Us, Vn } from 'react-flags-select';

// App language code -> the flag shown for it (one representative country each).
// The single source for every flag on web; add new languages here only.
const FLAGS: Record<string, React.ComponentType> = {
    en: Us,
    de: De,
    es: Es,
    fr: Fr,
    pl: Pl,
    ru: Ru,
    uk: Ua,
    ar: Sa,
    vi: Vn,
    pt: Br,
    nl: Nl,
    fa: Ir,
    it: It,
    tr: Tr,
    ja: Jp,
    bg: Bg,
    cs: Cz,
    fi: Fi,
    hr: Hr,
    hu: Hu,
    no: No,
    ro: Ro,
    sk: Sk,
    sr: Rs,
    sv: Se,
    mn: Mn,
};

export function getFlagIcon(code: string): React.ReactNode {
    const Flag = FLAGS[code];
    return Flag ? <Flag /> : null;
}
